var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$route)?_c('div',{staticClass:"flex-column",attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }